// extracted by mini-css-extract-plugin
module.exports = {"modal":"ProductQuickView_modal__11mfF","loading":"ProductQuickView_loading__2AuJh","spinAround":"ProductQuickView_spinAround__1S9rO"};